// extracted by mini-css-extract-plugin
export default {"textCenterOr":"shareModal_textCenterOr__ri+vK"};